import React, { useEffect,  useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { adminChangeDriverDocumentsStatusApi, adminChangePartnerApprovalStatus, adminGetAllUserList, adminGetDriverDetailsById, createOrUpdateVehicleDetailsApi, getVehicleCategoryListApi, savePartnerBankDetailsApi, updateDriverDocsApi, updatePartnerProfileApi, uploadFileApi, getBankDetailsApi } from '../../../utils/ApiEndpointFunctions';
import Spinwheel from '../../common/Spinwheel';
import { capitalizeWords, convertTo12HourFormat, dateFormat } from '../../../utils/HelperFuncitons';
import SelectedUserDetail from '../../common/SelectedUserDetail';
import { S3_URL } from '../../../utils/BaseUrl';
import ConfirmationModal from '../../common/ConfirmationModal';
import PdfSvgIcon from '../../common/PdfSvgIcon';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import toast from 'react-hot-toast';
import moment from 'moment';
import CommonTable from '../../common/Table/CommonTable';
import PartnerReviewTable from '../../common/PartnerReviewTable';
import AddOrUpdateDetails from '../../common/Modal/AddOrUpdateDetails';
import { useFormik } from 'formik';
import { bankDetailsInitialValue, bankDetailsValidationSchema, profileDetailsInitialValue, profileValidationSchema, vehicleInitialValue, vehicleValidationSchema } from '../../common/Validation';

const DriverDetails = (props) => {
    const [allDrivers, setAllDrivers] = useState([])
    const params = useParams();
    // const location = useLocation();
    // const path = location.pathname.split("/")
    const [id, setId] = useState(params?.id)
    const [driverDetails, setDriverDetails] = useState({});
    const [vehicleDetails, setVehicleDetails] = useState([]);
    const [bankDetails, setBankDetails] = useState([]);
    const [bonusDetails, setBonusDetails] = useState([]);
    const [loader, setLoader] = useState(true);
    const [activeTab, setActiveTab] = useState('driver');
    const [confirmStatus, setConfirmStatus] = useState({ status: "", userId: "", role: "driver" });
    const [selectedImg, setSelectedImg] = useState("")
    const confirmationModalId2 = "confirmationModal2"
    const driverBankModal2 = "driverBankModal2"
    const [keyNameForUpdate, setKeyNameForUpdate] = useState("")
    const [selectDocDate, setSelectDocDate] = useState("")
    const [detailsType,setDetailsType] = useState({type:"",loading:false})
    const [fileUpload,setFileUpload] = useState([])
    const [vehicleCategoryList,setVehicleCategoryList] = useState({list:[],categoryId:"",modelId:"",makeId:""})
    const [selectedDocument,setSelectedDocument] = useState({id:null,type:null,loading:false})


    const genderOptions = [
        {label:"Male",value:"male"},
        {label:"Female",value:"female"},
        {label:"Other",value:"other"},
    ]

    const detailsFields = {
        "bankDetails": {
            format: [
                { name: "bankName", label: "Bank Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "accountNo", label: "Account No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                { name: "accountType", label: "Account Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "Ifsc", label: "IFSC", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
            ],
            initialvalue: bankDetailsInitialValue,
            validationSchema: bankDetailsValidationSchema,
            handleSubmit: (values) => handleDriverDetailSubmit(values, savePartnerBankDetailsApi),
            modalId: driverBankModal2
        },
        "vehicle": {
            format: [
                { name: "categoryId", label: "Class", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.id == el?.id)?.[0]))?.map(ele => { return { label: ele?.category, value: ele?.id } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "makeId", label: "Make", type: "select", options: vehicleCategoryList?.list?.map(ele => { return { label: ele?.make, value: ele?.makeid } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "modelId", label: "Model", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.modelId == el?.modelId)?.[0]))?.map(ele => { return { label: ele?.model, value: ele?.modelId } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "year", label: "Year", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                { name: "color", label: "Color", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "licenseNo", label: "License number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "vehicleNumber", label: "Vehicle number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "vehicleCertificate", label: "Vehicle certificate", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("vehicleCertificate"), handleFileUpload },
                { name: "vehicleCertificateValidUpto", label: "Vehicle certificate valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "vehicleInsurance", label: "Vehicle insurance", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("vehicleInsurance"), handleFileUpload },
                { name: "insuranceCertificateValidUpto", label: "Insurance certificate valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
            ],
            initialvalue: vehicleInitialValue,
            validationSchema: vehicleValidationSchema,
            handleSubmit: (values) => handleDriverDetailSubmit({ ...values, categoryId: values?.categoryId?.value, makeId: values?.makeId?.value, modelId: values?.modelId?.value }, createOrUpdateVehicleDetailsApi),
            modalId: driverBankModal2
        },
        "driver": {
            format: [
                { name: "profileImage", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
                { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "alternateMobile", label: "Alternate mobile", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "zip", label: "Zip Code", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },

                { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "isAvailable", label: "Available", type: "select", options: [{ label: "Yes", value: true }, { label: "No", value: false }], handleOnChange: (...values) => handleInputChange(...values, "select") 
        }
            ],
            initialvalue: profileDetailsInitialValue,
            validationSchema: profileValidationSchema,
            handleSubmit: (values) => handleDriverDetailSubmit({ ...values, gender: values?.gender?.value , isAvailable: values?.isAvailable?.value }, updatePartnerProfileApi),
            modalId: driverBankModal2
        },
        "document": {
            format: [
                ...(selectedDocument.type == "Non-Conviction Certificate" ?
                    [
                        { name: "nonConvictionCertificate", label: "Non conviction certificate", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("nonConvictionCertificate"), handleFileUpload },
                    ] :
                    (selectedDocument.type == "Vehicle Registration Certificate" ?
                        [
                            { name: "vehicleCertificate", label: "Vehicle Registration Certificate", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("vehicleCertificate"), handleFileUpload },
                            { name: "vehicleCertificateValidUpto", label: "Valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
                        ] : (selectedDocument.type == "Vehicle Insurance" ?
                            [
                                { name: "vehicleInsurance", label: "Vehicle Insurance", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("vehicleInsurance"), handleFileUpload },
                                { name: "insuranceCertificateValidUpto", label: "Valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
                            ] : (selectedDocument.type == "Vehicle Image" ?
                                [
                                    { name: "vehicleImage", label: "Vehicle Image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("vehicleImage"), handleFileUpload },
                                ] : (
                                    selectedDocument.type == "Profile Image" ?
                                        [
                                            { name: "profileImage", label: "Profile Image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("licenceImage"), handleFileUpload },
                                        ] : (
                                            selectedDocument.type == "License" ?
                                                [
                                                    { name: "licenceImage", label: "License", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("licenceImage"), handleFileUpload },
                                                    { name: "licenseCertificateValidUpto", label: "Valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
                                                ] : [])))))

                ),
            ],
            initialvalue: profileDetailsInitialValue,
            // validationSchema:{},
            handleSubmit: (values) => {
                let preferredKeys = detailsFields[activeTab]?.format?.map(ele => ele?.name)
                let payload = {}
                preferredKeys?.map(ele => {
                    payload[ele] = values[ele]
                })
                console.log("preferredKeys", preferredKeys, payload);

                handleDriverDetailSubmit({ ...payload }, updateDriverDocsApi)
            },
            modalId: driverBankModal2
        }
    }

    const driverDetailsFormik = useFormik({
        initialValues:detailsFields?.[activeTab]?.initialvalue,
        validationSchema:detailsFields?.[activeTab]?.validationSchema,
        enableReinitialize:true,
        onSubmit:detailsFields?.[activeTab]?.handleSubmit
    })

    async function handleDriverDetailSubmit(payload,apiEndPoint){
        try {
            setDetailsType({...detailsType,loading:true})
            const res = await apiEndPoint({...payload,partnerUserId:id})
            if(res?.status==200 || res?.status==201){
                fetchDriverDetails();
                document.getElementById(detailsFields[activeTab]?.modalId)?.click()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
        }
        setDetailsType({...detailsType,loading:false})
    }


    async function handleFileUpload (name,e,formik){
        try {
          const file = e.target.files[0];
          if (file) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("type", "documents")
            setFileUpload([...fileUpload,name])
            const res = await uploadFileApi(formData)
            formik.setFieldTouched(name, true)
            if (res.status === 200 && res.data?.status === 1) {
              formik.setFieldValue(name, res.data?.data);
              toast.success("File uploaded");
            }
          }
        } catch (error) {
          formik.setFieldTouched(`image`, true)
          console.log(error)
          if (error?.response === undefined) {
            toast.error("File size is too large")
          }
        }
        setFileUpload([...fileUpload?.filter(ele=>ele!=name)])
      }

    const fetchDriverDetails = async () => {
        try {
            const res = await adminGetDriverDetailsById(id);
            if (res.status === 200) {
                const { id, role, phone, driverDetails,referralCode, partnerUserDetails, vehicles, bankDetails, driverBonus } = res.data.data;
                setDriverDetails({ id, phone, role,referralCode, ...driverDetails[0], ...partnerUserDetails[0] });
                setVehicleDetails(vehicles);
                setBankDetails(bankDetails)
                setBonusDetails(driverBonus)
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const fetchVehicleCategory = async (category="", make="", model="") => {
        try {
            const res = await getVehicleCategoryListApi(id,category,make,model);
            if (res.status === 200) {
                setVehicleCategoryList({...vehicleCategoryList,list:res.data?.data?.categoryList});
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getAllDrivers = async () => {
        try {
            const res = await adminGetAllUserList("", "", "", "driver");
            if (res.status === 200) {
                setAllDrivers(res.data?.data?.findPartners)
            }
        } catch (error) {

        }
    }

    

    const handleChangeStatus = async () => {
        try {
            setLoader(true)
            await adminChangePartnerApprovalStatus(confirmStatus)
            fetchDriverDetails();
            document.getElementById('confirmationModal').click()
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something Went Wrong")
            setLoader(false)
        }
    }

    const openModal = () => {
        document.getElementById('confirmationModal2Btn').click()
    }


    // Fetch bank details from API and set in table
    useEffect(() => {
        getAllDrivers();
        fetchVehicleCategory();
        fetchBankDetails();
    }, []);

    const fetchBankDetails = async () => {
        try {
            const res = await getBankDetailsApi();
            if (res.status === 200) {
                setBankDetails(res.data?.bankDetails || []);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (id) {
            fetchDriverDetails();
        }
    }, [id]);

    const toggleTab = (tab) => {
        setActiveTab(tab);
    };

    const handleChangeDocumentStatus = async (status, keyName) => {
        const promise = adminChangeDriverDocumentsStatusApi({ userId: id, keyName: keyName, status: status });
        toast.promise(
            promise,
            {
                loading: 'Updating document status...',
                success: (res) => {
                    if (res.status === 200) {
                        let driverDetailsTemp = { ...driverDetails }
                        if (keyName === "licenceApprovalStatus" || keyName === "profilePhotoApprovalStatus" || keyName === "nonConvictionCertificateApprovalStatus") {
                            driverDetailsTemp[keyName] = status
                        } else if (keyName === "vehicleCertificateApprovalStatus" || keyName === "vehicleInsuranceApprovalStatus" || keyName === "vehicleImageApprovalStatus") {
                            let vehicleDetailsTemp = [...vehicleDetails]
                            if (vehicleDetailsTemp && vehicleDetailsTemp.length) {
                                vehicleDetailsTemp[0][keyName] = status
                            }
                            setVehicleDetails(vehicleDetailsTemp)
                        }

                        if(res.data?.driverStatus){
                            driverDetailsTemp["driverStatus"] = res.data.driverStatus
                        }
                        setDriverDetails(driverDetailsTemp)
                        return res.data.message || 'Success';
                    } 
                },
                error: (err) => {
                    
                    return err.response?.data?.message || 'Something Went Wrong'
                }
            }
        )
    };

    const DocumentDisplay = ({ title, document, setSelectedImg, status, keyName, validUpto }) => {
        // if (!document) {
        //     return (
        //         <tr>
        //             <td>{title}</td>
        //             <td className='text-center'>{`${title} not available`}</td>
        //         </tr>
        //     );
        // }

        const isPdf = document ? document.split(".").slice(-1)[0] === "pdf" : "";

        return (
            <tr>
                <td>{title}</td>
                <td className='text-center'>
                    {isPdf ? (
                        <Link to={`${S3_URL}/${document}`} className="text-primary">
                            <PdfSvgIcon width="100" height="100" />
                        </Link>
                    ) : (
                        document ? 
                        <img
                            src={`${S3_URL}/${document}`}
                            alt={title}
                            data-bs-toggle="modal"
                            data-bs-target={`#imageViewModal`}
                            style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                            onClick={() => setSelectedImg(`${S3_URL}/${document}`)}
                        /> : ""
                    )}
                </td>
                <td className='text-center'>{validUpto ? dateFormat(validUpto) : ""}</td>
                <td className='text-center'>{ capitalizeWords(status) || "-"}</td>
                <td className='text-center'>
                    <div className="dropdown">
                        <button
                            className=" border-0 bg-white"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-three-dots-vertical"
                                viewBox="0 0 16 16"
                            >
                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                            </svg>
                        </button>
                        <ul
                            className="dropdown-menu"
                            style={{ zIndex: "1000" }}
                        >
                            {(status === "rejected" || status === "submitted") && <li
                                onClick={() =>{
                                    setSelectDocDate(validUpto);
                                    if(moment().toISOString() < moment(validUpto).toISOString()){
                                        handleChangeDocumentStatus('approved', keyName)
                                    }else if(validUpto==undefined){
                                        handleChangeDocumentStatus('approved', keyName)
                                    }else {
                                        setKeyNameForUpdate(keyName)
                                        openModal()
                                    }
                                }}
                            >
                                <a className="dropdown-item" href="#">
                                    Approve
                                </a>
                            </li>}

                            {(status === "approved" || status === "submitted") && <li
                                onClick={() =>
                                    handleChangeDocumentStatus('rejected', keyName)
                                }
                            >
                                <a className="dropdown-item" href="#">
                                    Reject
                                </a>
                            </li>}
                            <li     data-bs-toggle="modal" data-bs-target={`#${driverBankModal2}`} onClick={() =>{
                                setSelectedDocument({...selectedDocument,type:title});
                                driverDetailsFormik?.setValues({
                                    ...driverDetails,
                                    vehicleCertificate:vehicleDetails[0]?.vehicleCertificate,
                                    vehicleCertificateValidUpto:vehicleDetails[0]?.vehicleCertificateValidUpto,
                                    vehicleInsurance:vehicleDetails[0]?.vehicleInsurance,
                                    insuranceCertificateValidUpto:vehicleDetails[0]?.insuranceCertificateValidUpto,
                                    vehicleImage:vehicleDetails[0]?.vehicleImage,
                                    vehicleCertificate:vehicleDetails[0]?.vehicleCertificate,
                                    title,
                                    validUpto})}} >
                                <a className="dropdown-item" href="#">
                                    Edit
                                </a>
                            </li>
                        </ul>
                    </div>
                </td>
            </tr>
        );
    };

   

    const vehicleHeaderData = [
        { name: "License Number", className: "list-sort text-muted", key: "licenseNo" },
        { name: "Year", className: "list-sort text-muted", key: "year" },
        { name: "Class", className: "list-sort text-muted", key: "category" },
        { name: "Make", className: "list-sort text-muted", key: "make" },
        { name: "Model", className: "list-sort text-muted", key: "model" },
        { name: "Color", className: "list-sort text-muted", key: "color" },
        { name: "Vehicle Number", className: "list-sort text-muted", key: "vehicleNumber" },
        { name: "Vehicle Certificate", className: "list-sort text-muted", key: "vehicleCertificate" },
        { name: "Insurance", className: "list-sort text-muted", key: "vehicleInsurance" },
        { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div>{!vehicleDetails?.length && <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Add</button>}</div></div>, className: "col-1", key: "action" },

    ]

    const vehicleTableData = vehicleDetails.map((vhcl, index) => {
        return {
            licenseNo: vhcl.licenseNo,
            year: vhcl.year,
            category: vhcl?.category?.category,
            make: vhcl?.make?.make,
            model: vhcl?.model?.model,
            color: capitalizeWords(vhcl?.color) || "",
            vehicleNumber: vhcl?.vehicleNumber || "",
            vehicleCertificate: vhcl?.vehicleCertificate?.split(".")?.slice(-1)?.includes("pdf") ?
                <Link to={`${S3_URL}/${vhcl?.vehicleCertificate}`}  > <PdfSvgIcon width="100" height="100" /></Link>
                :
                <img
                    src={vhcl?.vehicleCertificate ? `${S3_URL}/${vhcl?.vehicleCertificate}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg"}
                    alt={"img"}
                    data-bs-toggle="modal"
                    data-bs-target={`#imageViewModal`}
                    style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                    onClick={() => { setSelectedImg(vhcl?.vehicleCertificate ? `${S3_URL}/${vhcl?.vehicleCertificate}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg") }}
                />,
            vehicleInsurance: vhcl?.vehicleInsurance?.split(".")?.slice(-1)?.includes("pdf") ?
                <Link to={`${S3_URL}/${vhcl?.vehicleInsurance}`}> <PdfSvgIcon width="100" height="100" /></Link>
                :
                <img
                    src={vhcl?.vehicleInsurance ? `${S3_URL}/${vhcl?.vehicleInsurance}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg"}
                    alt={"img"}
                    data-bs-toggle="modal"
                    data-bs-target={`#imageViewModal`}
                    style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
                    onClick={() => { setSelectedImg(vhcl?.vehicleInsurance ? `${S3_URL}/${vhcl?.vehicleInsurance}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg") }}
                />,
            action: (
                <div className="dropdown">
                    <button
                        className=" border-0 bg-white"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-three-dots-vertical"
                            viewBox="0 0 16 16">
                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                        </svg>
                    </button>
                    <ul
                        className="dropdown-menu"
                        style={{ zIndex: "1000" }}>
                        <li data-bs-toggle="modal" data-bs-target={`#${detailsFields?.[activeTab]?.modalId}`} onClick={() => { 
                            driverDetailsFormik?.setValues({
                                ...vhcl,
                                categoryId:{label:vhcl?.category?.category,value:vhcl?.category?.id,},
                                modelId:{label:vhcl?.model?.model,value:vhcl?.model?.id,},
                                makeId:{label:vhcl?.make?.make,value:vhcl?.make?.id,},

                                }) }}>
                            <a className="dropdown-item" href="#">
                                Edit
                            </a>
                        </li>
                    </ul>
                </div>
            )
        }
    })


    const bankDetailsHeaderData = [
        { name: "Account Holder Namer", className: "list-sort text-muted", key: "name" },
        { name: "Bank Name", className: "list-sort text-muted", key: "bankName" },
        { name: "IFSC", className: "list-sort text-muted", key: "Ifsc" },
        { name: "Account Number", className: "list-sort text-muted", key: "accountNo" },
        { name: "Account Type", className: "list-sort text-muted", key: "accountType" },
        { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div>{!bankDetails?.length && <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Add</button>}</div></div>, className: "col-1", key: "action" },

    ]

    const bankDetailsTableData = bankDetails.map((bnk, index) => ({
        name: driverDetails.name || "",
        bankName: bnk.bankName || "",
        Ifsc: bnk.Ifsc || "",
        accountNo: bnk.accountNo || "",
accountType: bnk.accountType && bnk.accountType.trim() !== "" 
  ? bnk.accountType 
  : bnk.type || "",
        action: (
            <div className="dropdown">
              <button
                className=" border-0 bg-white"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-three-dots-vertical"
                  viewBox="0 0 16 16">
                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                </svg>
              </button>
              <ul
                className="dropdown-menu"
                style={{ zIndex: "1000" }}>
                <li data-bs-toggle="modal" data-bs-target={`#${detailsFields?.[activeTab]?.modalId}`}  onClick={() =>{driverDetailsFormik?.setValues(bnk)}}>
                  <a className="dropdown-item" href="#">
                    Edit
                  </a>
                </li>
              </ul>
            </div>
          )
    }))

    const bonusHeaderData = [
        { name: "Name", className: "list-sort text-muted", key: "name" },
        { name: "Duration", className: "list-sort text-muted", key: "duration" },
        { name: "Amount", className: "list-sort text-muted", key: "amount" },
        { name: "Date", className: "list-sort text-muted", key: "updatedAt" },
    ]

    const bonusTableData = bonusDetails.map((bonus, index) => ({
        name: bonus?.bonus?.name || "",
        duration: `${capitalizeWords(bonus?.bonus?.duration) || ""}${bonus?.bonus?.duration === "period" ? ` (${convertTo12HourFormat(bonus?.bonus?.from)} - ${convertTo12HourFormat(bonus?.bonus?.to)})` : ""}`,
        amount: bonus?.bonus?.amount || "",
        updatedAt: bonus?.updatedAt ? dateFormat(bonus?.updatedAt) : ""
    }))


    const profileData = [
        { name: "Email", data: driverDetails.email, },
        { name: "Phone", data: driverDetails.phone, },
        { name: "Alternate Phone", data: driverDetails.alternateMobile, },
        { name: "Emergency Contact", data: driverDetails.emergencyContact, },
        { name: "NIN", data: driverDetails.NIN, },
        { name: "Status", data: capitalizeWords(driverDetails.driverStatus), },
        { name: "Role", data: driverDetails?.role?.map(el => capitalizeWords(el))?.join(", "), },
        { name: "Gender", data: driverDetails.gender, },
        { name: "City", data: driverDetails.city, },
        { name: "State", data: driverDetails.state, },
        { name: "Country", data: driverDetails.country, },
        { name: "Zip Code", data: driverDetails.zip, },
        { name: "License Number", data: vehicleDetails[0]?.licenseNo || "", },
        { name: "Driving Experience", data: (driverDetails.drivingExp || 0) + " years", },
        { name: "Address", data: <div>{driverDetails.permanentAddress && `${driverDetails.permanentAddress}, `}{driverDetails.city && `${driverDetails.city}, `}{driverDetails.state && `${driverDetails.state}, `}{driverDetails.zip && `${driverDetails.zip}`}</div>, },
        { name: "Available", data: driverDetails.isAvailable },
        { name: "Referral Code", data: driverDetails.referralCode, },
    ]

    useEffect(()=>{
       console.log("sdfsdfsdf",driverDetails)
    },[driverDetails])

    function handleInputChange(name,e,formik,input,type){
        if(input=="input"){
            const {value} = e?.target
            if(type=="number" && isNaN(value)) return
            formik.setFieldValue(name,value)
        }else if(input=="date"){
            formik.setFieldValue(name,e)
        }else if(input=="select"){
            let list = [{name,value:e}]
            if(name=="categoryId"){
                list.push({name:"modelId",value:""},{name:"makeId",value:""})
            }else if(name=="modelId"){
                list.push({name:"makeId",value:""})
            }

            list?.forEach(ele=>{
                formik.setFieldValue(ele?.name,ele?.value)
            })
        }else if(input=="address"){
            formik.setFieldValue(name,e?.label)
        }
        
    }




    const tabData = [
        {
            name: "Profile Details", tab: "driver", setTab: toggleTab, data: <div className="row card">
                <div className="row mt-3">
                    <div className='d-flex justify-content-end'>
<button
  className='btn btn-primary'
  onClick={() =>
    driverDetailsFormik.setValues({
      ...driverDetails,
      gender: {
        label: capitalizeWords(driverDetails?.gender),
        value: driverDetails?.gender
      },
      isAvailable: {
        label: driverDetails?.isAvailable ? "Yes" : "No",
        value: driverDetails?.isAvailable
      }
    })
  }
  data-bs-toggle="modal"
  data-bs-target={`#driverBankModal2`}
>
  Edit
</button>
                    </div>
                    <div className="user-details">
                        <table className="table table-md table-hover card-table">
                            <tbody>
  {
    profileData.map((ele, index) => {
      if (ele.name === "Available") {
        return (
          <tr key={index}>
            <td>{ele.name}:</td>
            <td>{ele.data ? "Yes" : "No"}</td>
          </tr>
        );
      }

      return (
        <tr key={index}>
          <td>{ele.name}:</td>
          <td>{ele.data}</td>
        </tr>
      );
    })
  }
</tbody>

                        </table>

                    </div>
                </div>
            </div>
        },
        { name: "Vehicle Details", tab: "vehicle", setTab: toggleTab, data: <div className="card row" ><CommonTable headers={vehicleHeaderData} data={vehicleTableData} /></div> },
        { name: "Bank Details", tab: "bankDetails", setTab: toggleTab, data: <div className="card row" ><CommonTable headers={bankDetailsHeaderData} data={bankDetailsTableData} /></div> },
        { name: "Bonus Details", tab: "bonus", setTab: toggleTab, data:  <div className="card row" ><CommonTable headers={bonusHeaderData} data={bonusTableData} /> </div>},
        {
            name: "Documents", tab: "document", setTab: toggleTab, data: <div className="row card ">
                <div className="table-responsive  " style={{ overflowX: "inherit" }}>
                    <table className="table table-md table-hover card-table">
                        <thead>
                            <tr>
                                <th> <span className="list-sort text-muted">Type</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">File</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Valid Upto</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Status</span></th>
                                <th className='text-center'> <span className="list-sort text-muted">Action</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <DocumentDisplay
                                title="License"
                                document={driverDetails?.licenceImage}
                                setSelectedImg={setSelectedImg}
                                status={driverDetails?.licenceApprovalStatus}
                                keyName={"licenceApprovalStatus"}
                                validUpto={driverDetails?.licenseCertificateValidUpto}
                            />
                            <DocumentDisplay
                                title="Profile Image"
                                document={driverDetails?.profileImage}
                                setSelectedImg={setSelectedImg}
                                status={driverDetails?.profilePhotoApprovalStatus}
                                keyName={"profilePhotoApprovalStatus"}
                            />
                            {driverDetails?.criminalBackground && (
                                <DocumentDisplay
                                    title="Non-Conviction Certificate"
                                    document={driverDetails?.nonConvictionCertificate}
                                    setSelectedImg={setSelectedImg}
                                    status={driverDetails?.nonConvictionCertificateApprovalStatus}
                                    keyName={"nonConvictionCertificateApprovalStatus"}
                                />
                            )}
                            <DocumentDisplay
                                title="Vehicle Registration Certificate"
                                document={vehicleDetails[0]?.vehicleCertificate}
                                setSelectedImg={setSelectedImg}
                                status={vehicleDetails[0]?.vehicleCertificateApprovalStatus}
                                keyName={"vehicleCertificateApprovalStatus"}
                                validUpto={vehicleDetails[0]?.vehicleCertificateValidUpto}

                            />
                            <DocumentDisplay
                                title="Vehicle Insurance"
                                document={vehicleDetails[0]?.vehicleInsurance}
                                setSelectedImg={setSelectedImg}
                                status={vehicleDetails[0]?.vehicleInsuranceApprovalStatus}
                                keyName={"vehicleInsuranceApprovalStatus"}
                                validUpto={vehicleDetails[0]?.insuranceCertificateValidUpto}
                            />
                            <DocumentDisplay
                                title="Vehicle Image"
                                document={vehicleDetails[0]?.vehicleImage}
                                setSelectedImg={setSelectedImg}
                                status={vehicleDetails[0]?.vehicleImageApprovalStatus}
                                keyName={"vehicleImageApprovalStatus"}
                            />
                        </tbody>
                    </table>
                </div>
            </div> },
         { name: "Review", tab: "review", setTab: toggleTab, data: <div className="card row" ><PartnerReviewTable id={params?.id}/></div> },
    ]    

    return (
        <div className="main-content">
            <div className="container-fluid">

                {/* <SelectedUserDetail
                    allDropdownData={allDrivers}
                    selectedUser={driverDetails}
                    userId={id}
                    setUserId={setId}
                    type="Driver"
                /> */}
                {loader ? (
                    <div className="text-center">
                        <Spinwheel />
                    </div>
                ) : (
                    <>
                        <div className="row align-items-end">
                            <div className="col-auto">
                                <div className="avatar avatar-xxl header-avatar-top mt-3">
                                    <img src={driverDetails?.profileImage ? `${S3_URL}/${driverDetails?.profileImage}` : "https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg"} alt="profile" className="avatar-img rounded-circle border border-4 border-body" />
                                </div>
                            </div>
                            <div className="col mb-3 ms-n3 ms-md-n2">
                                <h1 className="header-title">
                                    {capitalizeWords(driverDetails.name)}
                                </h1>
                            </div>
                            <div className="col-12 col-md-auto mt-2 mt-md-0 mb-md-3">
                                {(driverDetails.driverStatus === "pending") ? <><button type="button" className="btn btn-outline-primary me-2" data-bs-toggle="modal"
                                    data-bs-target={`#confirmationModal`}
                                    onClick={(e) => { setConfirmStatus( prevState => ({...prevState, status: "approved", userId: id })) }}>Approve</button>
                                    <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal"
                                        data-bs-target={`#confirmationModal`}
                                        onClick={(e) => { setConfirmStatus( prevState => ({...prevState, status: "rejected", userId: id })) }}>Reject</button></> :
                                    <div className={`badge fs-4  ${driverDetails.driverStatus === "approved" ? "bg-primary-soft" : "bg-secondary-soft"}`}>{capitalizeWords(driverDetails.driverStatus)}</div>
                                }
                            </div>
                        </div>

                        <div className='d-flex justify-content-between'>
                            <ul className="nav nav-tabs">
                                {
                                    tabData.map((ele,index) => (
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === ele.tab ? 'active' : ''}`}
                                                onClick={() => ele.setTab(ele.tab)}
                                            >
                                                {ele.name}
                                            </button>
                                        </li>
                                    ))
                                }
                            </ul>
                            <div>
                            </div>
                        </div>

                            {
                                tabData.map((ele, index) => (
                                    activeTab === ele.tab ? ele.data : null
                                ))
                            }
                        </>
                )}

                {<ConfirmationModal
                    handleConfirm={handleChangeStatus}
                    confirmStatus={confirmStatus}
                />}
                <ImageViewModal imgUrl={selectedImg} modalId={"imageViewModal"} />
                {console.log(selectDocDate)}
                <button id="confirmationModal2Btn" className='d-none'data-bs-toggle="modal"data-bs-target={`#${confirmationModalId2}`}></button>
                <ConfirmationModal modalId={confirmationModalId2} message={<>The document is already expired!<br/> Do you still want to continue?</>} handleConfirm={() => handleChangeDocumentStatus("approved", keyNameForUpdate)} title={"Warning!"} confirmStatus={""}/>
                <AddOrUpdateDetails formik={driverDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading}  modalId={driverBankModal2}/>
            </div>
        </div>

    );
};

export default DriverDetails;
